<div style="margin: 25px" role="contentinfo">
    <h1 mat-dialog-title style="text-align: center !important" *ngIf="data">
        {{ "success.saved" | translate }}</h1>
    <div mat-dialog-content style="text-align: center !important" *ngIf="data">
        <h2 style="font-weight: normal;">{{ "success.confirm" | translate }}</h2>
    </div>
    <div mat-dialog-content style="text-align: center !important" *ngIf="!data">
        <p>{{ "success.confirm" | translate }}</p>
    </div>
    <div mat-dialog-actions style="text-align: center !important" *ngIf="data">
        <button class="btn btn-wsib" (click)="clkok()"
            attr.aria-label="{{ 'success.confirm' | translate }}">{{ "success.ok" | translate }}</button>
    </div>
</div>